import { register } from "../../common/api";
import EventDispatcher from "../../common/EventDispatcher";
import { Global } from "../../common/global";

export default class Register {
  constructor() {
    // document.querySelector("#privacy_agree").addEventListener("click", this.updatePrivacyStatus.bind(this, true));
    document
      .querySelector("#register_sec #t_c_check")
      .addEventListener("click", this.updateTermsStatus.bind(this));
    document
      .querySelector("#register_sec #getOTPBtn")
      .addEventListener("click", this.onRegisterSubmit.bind(this, false));
    this.termsReg = document.querySelector("#terms_trigger-reg");
    this.termsBack = document.querySelector("#termsBack");
    this.termsReg.addEventListener(
      "click",
      this.hideAllAndShowByID.bind(this, "terms_scr")
    );
    this.termsBack.addEventListener("click", this.goBack.bind(this));
  }
  init(data) {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));
    this.termsAccepted = false;
    this.registered = false;
  }
  onEvents(data) {
    switch (data["message"]["event_type"]) {
      case "show_screen":
        this.showScreen(data["message"]["data"]);
        break;
      case "hide_screen":
        this.hideScreen(data["message"]["data"]);
        break;
    }
  }
  updateTermsStatus() {
    this.termsAccepted = !this.termsAccepted;

    if (this.termsAccepted) {
      document.querySelector("#t_c_check").classList.add("active");
      document
        .querySelector("#register_sec .checkbox")
        .classList.remove("error");
    } else {
      document.querySelector("#t_c_check").classList.remove("active");
    }
  }
  async showScreen(data) {
    if (data["screenKey"] !== "Register") return false;

    // const result= await register("John", "John@gmail.com", "8105106261",  "karnataka");
    // this.showNextScreen();
    // return false;

    this.registered = false;
    this.termsAccepted = false;
    document.querySelector("#t_c_check").classList.remove("active");
    document.querySelector("#register_sec #name").value = "";
    document.querySelector("#register_sec #mobile").value = "";
    document.querySelector("#register_sec #email").value = "";
    document.querySelector("#register_sec #state").value = "";

    document.querySelector("#register_sec").classList.add("active");
  }
  async onRegisterSubmit() {
    if (this.registered) return false;
    let isValid = this.validate();
    if (!isValid) return false;

    this.registered = true;
    document.querySelector("#loader").classList.add("active");
    const result = await register(
      Global.userName,
      Global.email,
      Global.mobile,
      Global.state
    );
    document.querySelector("#loader").classList.remove("active");

    if (result.statusCode !== 200) {
      document
        .querySelector("#register_sec #name")
        .parentElement.classList.remove("error");
      document
        .querySelector("#register_sec #mobile")
        .parentElement.classList.remove("error");
      document
        .querySelector("#register_sec #email")
        .parentElement.classList.remove("error");
      document
        .querySelector("#register_sec #state")
        .parentElement.classList.remove("error");

      this.registered = false;
      //totalLimitExceeded

      if (result.messageId === "invalidName") {
        document
          .querySelector("#register_sec #name")
          .parentElement.classList.add("error");
      }
      if (result.messageId === "invalidMobile") {
        document
          .querySelector("#register_sec #mobile")
          .parentElement.classList.add("error");
      }
      if (result.messageId === "invalidEmail") {
        document
          .querySelector("#register_sec #email")
          .parentElement.classList.add("error");
      }
      if (result.messageId === "invalidState") {
        document
          .querySelector("#register_sec #state")
          .parentElement.classList.add("error");
      }
      document.querySelector(".errorSec").innerHTML = result.message;
      document.querySelector(".errorSec").classList.add("active");
      this.errorTO && clearTimeout(this.errorTO);
      this.errorTO = setTimeout(() => {
        document.querySelector(".errorSec").classList.remove("active");
      }, 2000);
      return false;
    }

    this.showNextScreen();
  }
  validate() {
    let isValid = true;
    Global.userName = document
      .querySelector("#register_sec #name")
      .value.trim();
    Global.mobile = document
      .querySelector("#register_sec #mobile")
      .value.trim();
    Global.email = document.querySelector("#register_sec #email").value.trim();
    Global.state = document.querySelector("#register_sec #state").value.trim();

    if (Global.userName.length == 0) {
      document
        .querySelector("#register_sec #name")
        .parentElement.classList.add("error");
      isValid = false;
    } else {
      document
        .querySelector("#register_sec #name")
        .parentElement.classList.remove("error");
    }
    if (Global.mobile.length == 0 || isNaN(Global.mobile)) {
      document
        .querySelector("#register_sec #mobile")
        .parentElement.classList.add("error");
      isValid = false;
    } else {
      document
        .querySelector("#register_sec #mobile")
        .parentElement.classList.remove("error");
    }

    if (Global.email.length != 0) {
      if (
        !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          Global.email
        )
      ) {
        document
          .querySelector("#register_sec #email")
          .parentElement.classList.add("error");
        isValid = false;
      } else if (
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(Global.email)
      ) {
        document
          .querySelector("#register_sec #email")
          .parentElement.classList.remove("error");
      }
    }

    if (Global.state.length == 0) {
      document
        .querySelector("#register_sec #state")
        .parentElement.classList.add("error");
      isValid = false;
    } else {
      document
        .querySelector("#register_sec #state")
        .parentElement.classList.remove("error");
    }

    if (!this.termsAccepted) {
      document.querySelector("#register_sec .checkbox").classList.add("error");
      isValid = false;
    }

    return isValid;
  }

  hideAllAndShowByID(menuID) {
    document.querySelector("#terms_scr").classList.remove("active");
    if (menuID != null) {
      document.querySelector(`#${menuID}`).classList.add("active");
    }
  }
  goBack(v) {
    v.stopImmediatePropagation();
    this.hideAllAndShowByID(null);
  }

  showNextScreen() {
    this.hideScreen();
    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "show_screen",
        data: {
          screenKey: "CodeVerify",
        },
      },
    });
  }
  hideScreen() {
    document.querySelector("#register_sec").classList.remove("active");
  }
}
